export default "__VITE_ASSET__DHd5kUFQ__"